const ruMessages = {
  /* 01.General */
  "chat.end": "Перезапустите чат",
  "chat.endall": "Конец чат",
  "chat.cancel": "Отмена",
  "chat.cookie":
    "Этот цифровой помощник использует файлы cookie, чтобы обеспечить вам наилучшие впечатления.",
  "chat.learn": "Учить больше",
  "chat.minimize": "Свести к минимуму",
  "chat.hide": "Закрывать",
  "chat.hidebot.text": "Close заставит аватар исчезнуть на 15 минут.",
  "chat.hidebot": "Закрыть (скрыть) аватар",
  "chat.restart": "Начать сначала",
  "switch.language": "Смена языка",
  "switch.property": "Переключить свойство",
  "restart.converstation": "Перезапустить разговор",
  "chat.endtext": "Вы уверены, что хотите завершить текущий чат?",
  "check.availabity": "Проверить наличие свободных мест",
  "check.availabity.submit": "Представлять на рассмотрение",
  "check.availabity.cancel": "Отмена",
  "check.availabity.adults": "Взрослые ",
  "check.availabity.children": "Дети",
  "check.availabity.child.age": "Возраст - ребенок",
  "feedback.leave": "Оставьте отзыв",
  "feedback.leave.message": "Оставить сообщение",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "Отправить дело",
  "caseform.system": "Система",
  "caseform.loading.systems": "Загрузка систем...",
  "caseform.select.system": "Выберите систему",
  "caseform.error.systems": "Ошибка загрузки систем",
  "caseform.scenario": "Сценарий",
  "caseform.loading.scenarios": "Загрузка сценариев...",
  "caseform.select.scenario": "Выберите сценарий",
  "caseform.error.scenarios": "Ошибка загрузки сценариев",
  "caseform.topic": "Тема",
  "caseform.loading.topics": "Загрузка тем...",
  "caseform.select.topic": "Выберите тему",
  "caseform.error.topics": "Ошибка загрузки тем",
  "caseform.subject": "Тема",
  "caseform.description": "Описание",
  "caseform.submit": "Отправить",
  "caseform.cancel": "Отмена",
  "caseform.success.title": "Дело создано",
  "caseform.success.message": "Ваше дело успешно создано.",
  "caseform.success.caseNumber": "Номер дела:",
  "caseform.success.ok": "OK",
  "simpleaction.title": "Выберите действие",
  "simpleaction.body":
    "Пожалуйста, выберите один из следующих вариантов:{br}{b}Создать дело{/b}, чтобы отправить запрос в службу поддержки, или {b}Начать чат{/b}, чтобы связаться с агентом прямо сейчас.",
  "simpleaction.startchat": "Начать чат",
  "simpleaction.createcase": "Создать дело",
  "caseform.error.generic": "Ошибка при создании дела.",
  "caseform.error.generic.message":
    "Произошла ошибка при создании вашего дела. Пожалуйста, попробуйте позже.",
};
export default ruMessages;
